exports.is = require('./is');